"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BROADCAST_SAVE_TEMPLATE = exports.BROADCAST_GET_TEMPLATES = exports.BROADCAST_GET_EVENT_MEDIA = exports.BROADCAST_CREATE_SOURCE = void 0;
var BROADCAST_CREATE_SOURCE = exports.BROADCAST_CREATE_SOURCE = 'BROADCAST_CREATE_SOURCE';
var BROADCAST_GET_TEMPLATES = exports.BROADCAST_GET_TEMPLATES = 'BROADCAST_GET_TEMPLATES';
var BROADCAST_SAVE_TEMPLATE = exports.BROADCAST_SAVE_TEMPLATE = 'BROADCAST_SAVE_TEMPLATE';
var BROADCAST_GET_EVENT_MEDIA = exports.BROADCAST_GET_EVENT_MEDIA = 'BROADCAST_GET_EVENT_MEDIA';